import { CommonModule, DecimalPipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslocoModule } from "@ngneat/transloco";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { AlertModule } from "ngx-bootstrap/alert";

import { AlertComponent } from "./components/alert/alert.component";
import { AreaChartComponent } from "./components/charts/area-chart/chart.component";
import { PieChartComponent } from "./components/charts/pie-chart/pie-chart.component";
import { FormControlErrorsModule } from "./components/form-control-errors/form-control-errors.module";
import { LoaderComponent } from "./components/loader/loader.component";
import { SubscribeFormComponent } from "./components/subscribe-form/subscribe-form.component";
import { ConvertLpToUsdPipe } from "./pipes/convert-lp-to-usd.pipe";
import { ConvertToUsdPipe } from "./pipes/convert-to-usd.pipe";
import { ValueToDecimalPipe } from "./pipes/value-to-decimal.pipe";
import { WalletIdTruncatePipe } from "./pipes/wallet-id-truncate.pipe";
import { AlertService } from "./services/alert.service";
import { SwitchComponent } from './components/switch/switch.component';

@NgModule({
  declarations: [
    AlertComponent,
    ValueToDecimalPipe,
    LoaderComponent,
    WalletIdTruncatePipe,
    ConvertToUsdPipe,
    ConvertLpToUsdPipe,
    AreaChartComponent,
    PieChartComponent,
    SubscribeFormComponent,
    SwitchComponent,
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    AlertModule.forRoot(),
    NgxChartsModule,
    FormsModule,
  ],
  exports: [
    AlertComponent,
    ValueToDecimalPipe,
    LoaderComponent,
    WalletIdTruncatePipe,
    ConvertToUsdPipe,
    ConvertLpToUsdPipe,
    FormControlErrorsModule,
    AreaChartComponent,
    PieChartComponent,
    SubscribeFormComponent,
  ],
  providers: [AlertService, DecimalPipe],
})
export class SharedModule {}
